module.exports = __webpack_public_path__ + "img/Cert-BG.c11c9746.jpg";